import { CTAEngine } from '@/services/hooks/use-ctas-data'
import { Plan, User } from '@/types/user'
import { Workspace } from '@/types/workspace'

export function getCallToActionData(userContext: {
    user?: User
    userPlan?: Plan
    workspaces: Workspace[]
}): CTAEngine {
    const { user, userPlan, workspaces } = userContext

    return {
        isFree: userPlan === 'free' || userPlan === null,
        isPro: userPlan === 'pro',
        isBusiness: userPlan === 'business',
        noWorkspace: workspaces.filter((w) => w.role !== 'GUEST').length === 0,
        starterWorkspace: workspaces.find((w) => w.role === 'ADMIN' && w.plan === 'STARTER'),
        businessWorkspaceAdmin: workspaces.find((w) => w.role === 'ADMIN' && w.plan === 'BUSINESS'),
        businessWorkspaceMember: workspaces.find(
            (w) => w.role === 'MEMBER' && w.plan === 'BUSINESS',
        ),
        businessWorkspaceGuest: workspaces.find((w) => w.role === 'GUEST' && w.plan === 'BUSINESS'),
        businessAccountMember: user?.premium_status === 'teams_business_member',
        businessAccountAdmin: Boolean(user?.is_biz_admin),
    }
}
